<div
  *ngIf="config$ | async as config"
  [attr.data-start-index]="1"
  [attr.data-max-length]="config.totalPages"
  class="a-page-indicator a-page-indicator--numbered"
  [class.-disabled]="disabled"
>
  <button
    class="a-page-indicator__caret -left"
    type="button"
    [class.-end]="!config.hasPreviousPage"
    [disabled]="!config.hasPreviousPage"
    (click)="onPageClick(config.pageNumber - 1)"
  ></button>
  <div class="a-page-indicator__container">
    <button
      *ngFor="let page of config.pages; let pageIndex = index; trackBy: trackByFn"
      class="a-page-indicator__indicator"
      type="button"
      [class.tw-pointer-events-none]="PAGINATION_DOTS === page"
      [attr.data-index]="page"
      (click)="onPageClick(pageIndex)"
      [class.-selected]="pageIndex === config.pageNumber"
    >
      <span>
        {{ page }}
      </span>
    </button>
  </div>
  <button
    class="a-page-indicator__caret -right"
    type="button"
    [class.-end]="!config.hasNextPage"
    [disabled]="!config.hasNextPage"
    (click)="onPageClick(config.pageNumber + 1)"
  ></button>
</div>
